import React from 'react';
import pt from 'prop-types';

import { paymentMethodName, paymentMethodManualIcon } from 'utils/payment';
import { formatPaymentBrand } from 'utils/order';

import Tooltip from 'components/tooltip';
import AppIcon from 'components/apps/icon';

import Icon from './icon';

import './icon.scss';

const CARD_BRANDS = {
  amex: 'amex',
  'american express': 'amex',
  cirrus: 'cirrus',
  dinersclub: 'dinersclub',
  'diners club': 'dinersclub',
  diners: 'dinersclub',
  discover: 'discover',
  jcb: 'jcb',
  maestro: 'maestro',
  mastercard: 'mastercard',
  visa: 'visa',
};

const FA_PAYMENT_ICONS = {
  amazon: 'amazon-pay',
  apple: 'apple-pay',
  paypal: 'paypal',
};

const MANUAL_PAYMENTS = {
  giftcard: 'gift',
  account: 'check',
  bank: 'bank',
  bank_deposit: 'bank',
  wire: 'bank',
};

export default class IconPayment extends React.PureComponent {
  static contextTypes = {
    client: pt.object,
  };

  static propTypes = {
    method: pt.string,
    card: pt.shape({
      brand: pt.string,
    }),
    tooltip: pt.bool,
    settings: pt.object,
  };

  getMethodName() {
    const { method, card, settings } = this.props;

    if (
      method === 'card' &&
      typeof card?.brand === 'string' &&
      Object.hasOwn(CARD_BRANDS, card.brand.toLowerCase())
    ) {
      return `${formatPaymentBrand(card.brand)} ${paymentMethodName(
        method,
        settings,
      ).toLowerCase()}`;
    }

    return paymentMethodName(method, settings);
  }

  renderIcon() {
    const { method, card = {}, settings = {} } = this.props;

    if (method === 'card') {
      const brand = CARD_BRANDS[String(card?.brand || '').toLowerCase()];

      return brand ? (
        <Icon
          className="icon-payment-fa icon-payment-card"
          fa={`cc-${brand}`}
          faType="brand"
        />
      ) : (
        <i className="icon icon-payment manual-card" />
      );
    }

    // if (CARD_BRANDS[card.brand]) {
    //   return <i className={`icon icon-payment ${CARD_BRANDS[card.brand]}`} />;
    // }

    if (Object.hasOwn(FA_PAYMENT_ICONS, method)) {
      return (
        <Icon
          className="icon-payment-fa"
          fa={`cc-${FA_PAYMENT_ICONS[method]}`}
          faType="brand"
        />
      );
    }

    if (method === 'ideal') {
      return (
        <Icon className="icon-payment-fa" fa="ideal" faType="brand" />
      );
    }

    switch (method) {
      case 'swell':
      case 'affirm':
      case 'resolve':
      case 'klarna':
      case 'bancontact':
      case 'google':
      case 'twint':
      case 'paysafecard':
      case 'sezzle':
        return <i className={`icon icon-payment ${method}`} />;

      default:
        break;
    }

    // Custom manual payment icon
    if (settings?.methods) {
      const icon = paymentMethodManualIcon(method, settings);

      if (icon) {
        return <i className={`icon icon-payment manual-${icon}`} />;
      }
    }

    if (Object.hasOwn(MANUAL_PAYMENTS, method)) {
      const manualIcon = MANUAL_PAYMENTS[method];

      if (manualIcon === 'bank') {
        return (
          <Icon className="icon-payment-fa" fa="building-columns" />
        );
      }

      return (
        <i className={`icon icon-payment manual-${manualIcon}`} />
      );
    }

    // App extension payment method icon
    const installedApp = this.context.client?.apps?.results?.find((a) =>
      a.app?.extensions?.some(
        (ext) => ext.type === 'payment' && ext.id === method,
      ),
    );
    if (installedApp?.app) {
      return <AppIcon app={installedApp.app} size={20} />;
    }

    // Default to cash
    if (method) {
      return (
        <Icon className="icon-payment-fa" fa="money-bill" faType="light" />
      );
    }

    return <i className="icon icon-payment icon-payment-none" />;
  }

  render() {
    const { tooltip = false } = this.props;

    if (tooltip) {
      return (
        <Tooltip message={this.getMethodName()} dir="left" delayed>
          {this.renderIcon()}
        </Tooltip>
      );
    }

    return this.renderIcon();
  }
}
